export const enum StorageKey {
    Entities = "FHIRPathUIEntities",
    Workspace = "FHIRPathUIWorkspace",
}
